export default function destroys (self) {
  const oldDestroy = self._destroy
  self._destroyables = []
  self._destroy = (...args) => {
    self._destroyables.forEach(callFn(...args))
    oldDestroy.apply(self, args)
  }

  self.destroys = (...args) => {
    // Keep it fresh and immutable
    self._destroyables = [].concat(self._destroyables, args)
  }
}

function callFn (...args) {
  return fn => {
    if (typeof fn === 'function') {
      return fn(...args)
    }
  }
}
